export enum NotificationTypes {
	SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning',
	INFO = 'info',
	OPEN = 'open',
}
